module.exports = __webpack_public_path__ + "media/images/weather-icons/fill/thunderstorms-day-snow-6863d8b64fbacb94f270e99b8d4e8fc8.svg";